const bannerList = ref<Record<string, unknown[]>>({});
const loaded = ref(false);
const BANNER_WAIT_INTERVAL_MS = 10;
const BANNER_WAIT_TIMEOUT_MS = 1000;

async function fetchBanners(locale = "hu", region = "hu") {
	let url = `/banners?locale=${locale}&region=${region.toLowerCase()}`;

	if (globalConfig.isBlue) {
		url = `/banners?locale=${locale}&region=blue`;
	}

	try {
		const data = await $fetch<Record<string, unknown[]>>(globalConfig.API + url);
		if (data) {
			bannerList.value = data;
			loaded.value = true;
		}
	} catch (error: any) {
		console.error("fetchBanners", error.message || error);
		loaded.value = true;
	}
}

async function getBanner(type = "") {
	if (!loaded.value && process.server) {
		return {};
	}

	const startedAt = Date.now();

	while (loaded.value !== true && Date.now() - startedAt < BANNER_WAIT_TIMEOUT_MS) {
		await new Promise((resolve) => setTimeout(resolve, BANNER_WAIT_INTERVAL_MS));
	}

	if (loaded.value !== true) {
		return {};
	}

	const bannerTypeList = bannerList.value[type] || [];
	return bannerTypeList.length > 0 ? bannerTypeList[getRandomIntInclusive(0, bannerTypeList.length - 1)] : {};
}

function getRandomIntInclusive(min: number, max: number) {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
}

export default {
	fetchBanners,
	getBanner,
};
